<template>
  <div>
    <CContainer>
      <h1 class="sr-only">{{ $t("sidebar_items.tardy_reports") }}</h1>
      <TardyReportsTable />
    </CContainer>
  </div>
</template>
<script>
import { onMounted } from "vue"
import { useI18n } from "vue-i18n"
import TardyReportsTable from "@/v3components/Datatables/TardyReportsTable.vue"

export default {
  name: "TardyManagementReports",
  components: { TardyReportsTable },
  setup() {
    const { t } = useI18n()

    onMounted(() => {
      document.title = `${t("sidebar_items.tardy_reports")} · Securly Pass`
    })

    return {}
  }
}
</script>
